import { themeGet } from '@styled-system/theme-get';
import styled, { css } from 'styled-components';

import { Link as LinkUnited } from '@olist/united';

export const MelhorUso = styled.section`
  h2 {
    max-width: 500px;
    margin: 0 auto;
    margin-bottom: 30px;
    text-align: center;
  }
  .content {
    display: flex;
    justify-content: space-evenly;
    margin: calc(-30px / 2);
    ${({ theme }) => {
      return (
        theme &&
        css`
          @media (max-width: ${theme.breakpoints.medium}) {
            flex-direction: column;
          }
        `
      );
    }}
    .card {
      border-radius: calc(30px / 2);
      box-shadow: 0px 3px 6px #00000029;
      margin: 30px/2;
      padding: 20px;
      transition: 0.3s;
      width: 25%;
      ${({ theme }) => {
        return (
          theme &&
          css`
            @media (max-width: ${theme.breakpoints.medium}) {
              width: calc(100% - 40px);
            }
          `
        );
      }}
      &:hover {
        box-shadow: 0px 3px 12px #00000029;
        transform: scale(1.05);
      }
      img {
        margin-bottom: calc(30px / 2);
        width: 100%;
      }
      a {
        text-decoration: none;
      }
      p {
        color: #364ef7;
        margin-bottom: calc(30px / 2);
        strong {
          color: black;
          font-size: 20px;
          ${({ theme }) => {
            return (
              theme &&
              css`
                @media (max-width: ${theme.breakpoints.medium}) {
                  font-size: 16px;
                }
              `
            );
          }}
        }
      }
      span {
        align-items: center;
        color: #364ef7;
        display: flex;
        font-weight: bold;
        justify-content: flex-start;
        ${({ theme }) => {
          return (
            theme &&
            css`
              @media (max-width: ${theme.breakpoints.medium}) {
                font-size: 12px;
              }
            `
          );
        }}
        &:hover {
          .icon {
            transform: translateX(50%);
          }
        }
        svg {
          fill: #364ef7;
          margin-left: calc(30px / 2);
          transition: 0.3s;
          width: calc(30px / 2);
        }
      }
    }
  }
`;

export const Link = styled(LinkUnited)`
  background-color: #0c29d0;
  border: 1px solid #0c29d0;
  border-radius: ${themeGet('olist.borderRadius.pill')};
  color: #ffffff;
  display: flex;
  height: 48px;
  margin: 0 auto;
  margin-top: 32px;
  margin-top: calc(30px * 2);
  padding: 0px 24px;
  width: max-content;
  width: fit-content;
  &:hover {
    background-color: #0c29d0 !important;
    border: 1px solid #0c29d0 !important;
    box-shadow: none !important;
    color: #ffffff !important;
    svg {
      margin-left: 10px;
      width: 12px;
    }
  }
  svg {
    display: block;
    margin-left: 0px;
    overflow: hidden;
    transition: 0.3s;
    width: 0;
    path {
      fill: #ffffff !important;
    }
  }
  a {
    color: #ffffff;
    text-decoration: none;
  }
`;

export const Container = styled.div`
  align-items: center;
  box-sizing: border-box;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1440px;
  padding: 0 80px;
  ${({ theme }) => {
    return (
      theme &&
      css`
        @media (max-width: ${theme.breakpoints.medium}) {
          padding: 0 16px;
          flex-direction: column;
        }
      `
    );
  }}
`;
